import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SectionFormPresenter from "./SectionFormPresenter";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";

class SectionFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      office: [],
      division: [],
      region: [],
      selectedRegion: { name: "" },
      selectedOffice: { name: "" },
      officeName: { name: "" },
      selectedDivision: { name: "" },
    };
    this.presenter = new SectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "Sections";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const allRegion = await findObjectUseCase().execute("Region");
    const region = allRegion.filter((data) => data.status === "active");
    this.setState({ region });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.loadRegion();
    }
  }
  async loadRegion() {
    const { object } = this.state;
    if (object.name) {
      const query = {
        where: {
          status: "active",
        },
      };
      const region = await findObjectUseCase().execute("Region", query);
      const selected = region.find((item) => item.id === object.region);
      this.setState({
        region,
        selectedRegion: { id: selected?.id, name: selected?.name },
      });
      this.loadOfficeData(object, query);
    }
  }

  async loadOfficeData(object, query) {
    const officeQuery = {
      where: {
        ...query.where,
        region: object.region,
      },
    };
    if (object.region) {
      const office = await findObjectUseCase().execute("offices", officeQuery);
      const selected = office.find((item) => item.id === object.office);
      this.setState({
        office,
        selectedOffice: { name: selected?.name, id: selected?.id },
      });
      this.loadDivisionData(object, query);
    }
  }

  async loadDivisionData(object, query) {
    const divisionQuery = {
      where: {
        ...query.where,
        office: object.office,
      },
    };
    if (object.office) {
      const division = await findObjectUseCase().execute(
        "Division",
        divisionQuery
      );
      const selected = division.find((item) => item.id === object.division);
      this.setState({
        division,
        selectedDivision: { name: selected?.name, id: selected.id },
      });
    }
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  handleRegionChange = async (selectedRegion) => {
    this.setState({ selectedRegion });
    const query = {
      where: {
        status: "active",
        region: selectedRegion.id,
      },
    };
    this.presenter.onChange();
    if (selectedRegion === "") {
      this.setState({
        office: [],
        division: [],
        selectedOffice: "",
        selectedDivision: "",
      });
    }
    if (selectedRegion) {
      const office = await findObjectUseCase().execute("offices", query);
      this.setState({ office, selectedOffice: "" });
    }
  };

  handleOfficeChange = async (selectedOffice) => {
    this.setState({ selectedOffice });
    const query = {
      where: {
        status: "active",
        office: selectedOffice.id,
      },
    };
    if (selectedOffice === "") {
      this.setState({ division: [], selectedDivision: "" });
    }
    if (selectedOffice) {
      const division = await findObjectUseCase().execute("Division", query);
      this.setState({ division, selectedDivision: "" });
    }
    this.presenter.onChange();
  };

  handleDivisionChange = (selectedDivision) => {
    this.setState({ selectedDivision });
    this.presenter.onChange();
  };

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getStateRegion() {
    return this.state.selectedRegion.id;
  }

  getStateOffice() {
    return this.state.selectedOffice.id;
  }

  getStateDivision() {
    return this.state.selectedDivision.id;
  }

  onChange(value, field) {
    this.setState({ [field]: value });
  }

  render() {
    const object = this.state.object;
    const { region, office, division } = this.state;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="p-0">
                          <label>
                            Name <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="name"
                            object={object}
                            placeholder="name"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            Description <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="description"
                            object={object}
                            placeholder="description"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            OCOM <span className="text-danger">*</span>
                          </label>
                          <SearchSelect
                            focus={true}
                            value={this.state.selectedRegion?.name}
                            onChange={this.handleRegionChange}
                            onClickClear={() => this.handleRegionChange("")}
                            disabled={region.length < 1}
                            options={region.map((officeItem) => ({
                              label: officeItem.name,
                              value: {
                                name: officeItem.name,
                                id: officeItem.id,
                              },
                            }))}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            Location <span className="text-danger">*</span>
                          </label>

                          <SearchSelect
                            focus={true}
                            value={this.state.selectedOffice?.name}
                            onChange={this.handleOfficeChange}
                            onClickClear={() => this.handleOfficeChange("")}
                            disabled={office.length < 1}
                            options={office.map((officeItem) => ({
                              label: officeItem.name,
                              value: {
                                name: officeItem.name,
                                id: officeItem.id,
                              },
                            }))}
                            placeholder="Select Location"
                          />
                        </div>

                        {/* DIvision  */}
                        <div className="p-0">
                          <label>
                            Region <span className="text-danger">*</span>
                          </label>

                          <SearchSelect
                            focus={true}
                            value={this.state.selectedDivision?.name}
                            onChange={this.handleDivisionChange}
                            onClickClear={() => this.handleDivisionChange("")}
                            disabled={division.length < 1}
                            options={division.map((divisionItem) => ({
                              label: divisionItem.name,
                              value: {
                                name: divisionItem.name,
                                id: divisionItem.id,
                              },
                            }))}
                            placeholder="Select Region"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(SectionFormPage);
